enum LocaleOptions {
  JA = 'ja',
}

export default LocaleOptions;
